import type { AvailabilityStatus } from '@psp-aggregator/sdk';

export type OfferStatusLabelKey = 'status.active' | 'status.paused';

export const OFFER_STATUS_I18N_KEY: Record<
  AvailabilityStatus,
  OfferStatusLabelKey
> = {
  active: 'status.active',
  paused: 'status.paused',
};

export const OFFER_STATUS_FILTER_OPTIONS: readonly AvailabilityStatus[] = [
  'active',
  'paused',
] as const;
